import React, { useState, useEffect, useContext, useRef } from 'react';
import './VoiceAssistant.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import TimelineText from '@/v2/components/atoms/TimelineText';
import VoiceAssistant from '@/v2/components/atoms/Icon/VoiceAssistant';
import Fade from '@/v2/components/atoms/Fade';
import TimeController from '@/v2/components/controllers/TimeController';
import Header from '@/v2/components/application/Header';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { ConnectivityContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';
import { timeout, saveTimeout, clearTimeouts } from '@/v2/components/utils/Timeout';

let videoController = null;

const videoReady = (controller, onReady) => {
    videoController = controller;
    onReady();
};

const play = () => {
    videoController.Play();
};

export default ({ isActive, data, onFinished, onReady }) => {
    const [animate, setAnimate] = useState('enter');
    const [{ disclaimer }] = useContext(ConnectivityContext);
    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    const time = useRef(TimelineText.Time());

    const videoFinished = () => {
        // delaying execution till video playback finishes
        timeout(onFinished, 800);
    };

    const transitionOut = () => {
        setAnimate('leave');
        timeout(play, 800);
    };

    const activate = () => {
        const timeController = new TimeController(time.current.Set);
        saveTimeout(timeController.AddTimeoutFromTimeline(data.text.timeline, () => transitionOut()));
    };

    useEffect(() => () => clearTimeouts(), []);

    useEffect(() => {
        if (isActive) {
            activate();
        }
    }, [isActive]);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
        }
    }, [isActive, videoController]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, onReady),
        autoPlay: false,
        onFinished: () => {
            videoFinished(onFinished);
        },
    };

    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} dark /> : '';

    return (
        <div className={`Connectivity-VoiceAssistant Connectivity-VoiceAssistant--${animate}`}>
            <VideoSimple src={data.video} options={options} />
            <TimelineText data={data.text.timeline} time={time.current} background="light" color="black" />
            <Header show={isActive} hideLogo dark />
            <div className="Connectivity-VoiceAssistant__icon">
                <VoiceAssistant />
            </div>
            {disclaimerContent}
            <Fade show={!isActive} light cover disableFadeIn />
        </div>
    );
};
